import React from 'react';
import { useNavigate } from 'react-router-dom';
import TicketReaderList from './TicketReaderList';
import AgilysysPOSList from './AgilysysPOSList';
import KitchenPrinterList from './KitchenPrinterList';
import GatemasterPOSList from './GatemasterPOSList';
import AccessPointList from './AccessPointList';
import SignPlayerList from './SignPlayerList';
import SwitchList from './SwitchList';
import GateWaveList from './GateWaveList';
import { Container, Row, Col, Button, Tabs, Tab } from 'react-bootstrap';
import styles from '../../CSS/DeviceList.module.css';

export const route = "/it/device/list";
export const role = "IT";

function DeviceList() {
    const navigate = useNavigate();
    const deviceTypes = ["Ticket Reader", "Agilysys POS", "Kitchen Printer", "Gatemaster POS", "Switch", "Sign Player", "Access Point", "Gate Wave"];

    return (
        <Container className={`my-5 ${styles.container}`}>
            <Row className="mb-4">
                <Col>
                    <h1>Device List</h1>
                    <Button onClick={() => navigate('/it/device/create')} className="btn btn-primary mt-3">
                        Create +
                    </Button>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col>
                    <Tabs id="device-type-tabs" className="mb-3">
                        {deviceTypes.map(type => (
                            <Tab eventKey={type} title={type} key={type}>
                                {type === 'Ticket Reader' && <TicketReaderList />}
                                {type === 'Agilysys POS' && <AgilysysPOSList />}
                                {type === 'Kitchen Printer' && <KitchenPrinterList />}
                                {type === 'Gatemaster POS' && <GatemasterPOSList />}
                                {type === 'Switch' && <SwitchList />}
                                {type === 'Sign Player' && <SignPlayerList />}
                                {type === 'Access Point' && <AccessPointList />}
                                {type === 'Gate Wave' && <GateWaveList />}
                            </Tab>
                        ))}
                    </Tabs>
                </Col>
            </Row>
        </Container>
    );
}

export default DeviceList;